import { render, staticRenderFns } from "./cardManagement.vue?vue&type=template&id=29815890&scoped=true&"
import script from "./cardManagement.vue?vue&type=script&lang=js&"
export * from "./cardManagement.vue?vue&type=script&lang=js&"
import style0 from "./cardManagement.vue?vue&type=style&index=0&id=29815890&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29815890",
  null
  
)

export default component.exports